<template>
  <div
    :style="
      $vuetify.breakpoint.width < 600
        ? {
            marginBottom: '320px',
          }
        : ''
    "
    class="pb-10"
  >
    <!-- #region 帳號與安全 -->
    <div class="text-h6 my-6 py-2 font-weight-black">{{ account.title }}</div>
    <div class="d-flex py-4">
      <v-avatar color="grey lighten-4" size="44">
        <v-icon>{{ account.icon }}</v-icon></v-avatar
      >
      <div class="ml-3">
        <div class="font-weight-black">{{ account.text }}</div>
        <div class="mt-1 mb-2 text-body-2">{{ account.desc }}</div>
        <v-btn large>{{ account.btn.text }}</v-btn>
      </div>
    </div>
    <v-divider></v-divider>
    <!-- #endregion -->
    <!-- #region 安全性 -->
    <div class="text-h6 pt-6 font-weight-black">
      {{ safety.title }}
    </div>
    <!-- #region 密碼 -->
    <div class="d-flex py-4">
      <v-avatar color="grey lighten-4" size="44">
        <v-icon>{{ safety.pwd.icon }}</v-icon></v-avatar
      >
      <div class="ml-3">
        <div class="font-weight-black">{{ safety.pwd.text }}</div>
        <div class="mt-1 mb-2 text-body-2">
          {{
            safety.pwd.isThirdParty
              ? safety.pwd.thirdParty
              : safety.pwd.desc + safety.pwd.updateDate
          }}
        </div>
        <v-btn
          v-if="!safety.pwd.isThirdParty"
          large
          @click="updatePwdDialog.show = true"
          >{{ safety.pwd.btn.text }}</v-btn
        >
      </div>
    </div>
    <v-divider class="pb-6"></v-divider>
    <!-- #endregion -->
    <!-- #region 刪除帳號 -->
    <div class="d-flex py-4">
      <v-avatar color="grey lighten-4" size="44">
        <v-icon>{{ safety.delete.icon }}</v-icon></v-avatar
      >
      <div class="ml-3">
        <div class="font-weight-black">{{ safety.delete.text }}</div>
        <div class="mt-1 mb-2 text-body-2">
          {{ safety.delete.desc }}
        </div>
        <v-btn large>{{ safety.delete.btn.text }}</v-btn>
      </div>
    </div>
    <v-divider></v-divider>
    <!-- #endregion -->
    <!-- #endregion -->
    <!-- #region 更新密碼彈窗 -->
    <v-dialog v-model="updatePwdDialog.show" max-width="345">
      <v-card>
        <v-card-title class="text-h6 font-weight-black">
          {{ updatePwdDialog.title }}
        </v-card-title>
        <v-card-text class="py-4 text--primary">
          <div>
            {{ updatePwdDialog.desc }}
          </div>
          <v-form ref="form" lazy-validation>
            <v-text-field
              class="mt-4"
              v-model="updatePwdDialog.field1.value"
              :label="updatePwdDialog.field1.label"
              :rules="updatePwdDialog.field1.rules"
              :error-messages="updatePwdDialog.field1.errorMsg"
              :hint="updatePwdDialog.field1.hint"
              :type="updatePwdDialog.field1.showPwd ? 'text' : 'password'"
              :append-icon="
                updatePwdDialog.field1.showPwd ? 'mdi-eye-off' : 'mdi-eye'
              "
              @click:append="
                updatePwdDialog.field1.showPwd = !updatePwdDialog.field1.showPwd
              "
              validate-on-blur
              persistent-hint
              outlined
              dense
            ></v-text-field>
            <v-text-field
              class="mt-4"
              v-model="updatePwdDialog.field2.value"
              :label="updatePwdDialog.field2.label"
              :rules="updatePwdDialog.field2.rules"
              :error-messages="updatePwdDialog.field2.errorMsg"
              :hint="updatePwdDialog.field2.hint"
              :type="updatePwdDialog.field2.showPwd ? 'text' : 'password'"
              :append-icon="
                updatePwdDialog.field2.showPwd ? 'mdi-eye-off' : 'mdi-eye'
              "
              @click:append="
                updatePwdDialog.field2.showPwd = !updatePwdDialog.field2.showPwd
              "
              @keyup.enter="UpdatePwd()"
              validate-on-blur
              persistent-hint
              outlined
              dense
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4 pt-2">
          <v-spacer></v-spacer>
          <v-btn @click="CancelUpdatePwd()">
            {{ updatePwdDialog.cancel }}
          </v-btn>
          <v-btn
            color="primary"
            @click="UpdatePwd()"
            :loading="updatePwdDialog.loading"
          >
            {{ updatePwdDialog.confirm }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- #endregion -->

    <!-- #region 更新成功彈窗 -->
    <v-dialog
      v-model="updateSuccessDialog.show"
      max-width="345"
      width="345"
      persistent
    >
      <v-card>
        <v-card-title class="text-h6 font-weight-black">
          {{ updateSuccessDialog.title }}
        </v-card-title>
        <v-card-text class="py-4">
          <div align="center">
            <v-img :src="updateSuccessDialog.img" max-width="155"></v-img>
            <div class="green--text text-h6 font-weight-black mt-6 mb-1">
              {{ updateSuccessDialog.title }}
            </div>
            <div class="text--primary">
              {{ updateSuccessDialog.desc }}
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="pa-4 pt-2">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="ReLogin()">
            {{ updateSuccessDialog.btnText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- #endregion -->
  </div>
</template>

<script>
import { Account_GetAccountSetting, Account_UpdatePwd } from "@/apis/api";

export default {
  data() {
    return {
      userEmail: "",
      account: {
        title: "帳號與安全",
        icon: "mdi-account-supervisor-circle",
        text: "綁定",
        desc: "啟用汪汪工作站需先綁定身分證",
        btn: {
          text: "開始綁定",
          loading: false,
          disabled: false,
        },
      },
      safety: {
        title: "安全性",
        pwd: {
          isThirdParty: false,
          thirdParty: "您使用Google登入小芋頭，請前往您的Google帳戶更改密碼。",
          updateDate: "",
          icon: "mdi-lock-outline",
          text: "密碼",
          desc: "密碼上次更新日期 : ",
          btn: {
            text: "修改密碼",
            loading: false,
            disabled: false,
          },
        },
        delete: {
          icon: "mdi-delete-outline",
          text: "刪除帳號",
          desc: "當您刪除帳號後，您將無法再登入小芋頭與使用產品",
          btn: {
            text: "刪除帳號",
            loading: false,
            disabled: false,
          },
        },
      },
      updatePwdDialog: {
        show: false,
        title: "修改密碼",
        desc: "請於下方欄位輸入新密碼，修改密碼成功後，請使用新密碼重新登入小芋頭。",
        field1: {
          value: "",
          label: "請輸入密碼",
          placeholder: "",
          rules: [
            (v) => !!v || "此欄位必填",
            (v) => v.length >= 6 || "長度最少需為6個字元",
            (v) => v.length <= 20 || "長度需少於20個字元",
            (v) => /[A-Za-z]+/.test(v) || "至少包含一個英文",
            (v) => /\d+/.test(v) || "至少包含一個數字",
            (v) => /^[a-zA-Z0-9~!@#$%&_?]+$/.test(v) || "請輸入英文或數字",
          ],
          errorMsg: "",
          hint: "請輸入最少6個字元，混合英數字之密碼",
          showPwd: false,
        },
        field2: {
          value: "",
          label: "再次輸入新密碼",
          placeholder: "",
          rules: [
            (v) => !!v || "此欄位必填",
            (v) => v.length >= 6 || "長度最少需為6個字元",
            (v) => v.length <= 20 || "長度需少於20個字元",
            (v) => /[A-Za-z]+/.test(v) || "至少包含一個英文",
            (v) => /\d+/.test(v) || "至少包含一個數字",
            (v) => /^[a-zA-Z0-9~!@#$%&_?]+$/.test(v) || "請輸入英文或數字",
          ],
          errorMsg: "",
          showPwd: false,
        },
        cancel: "取消",
        confirm: "確認修改",
        loading: false,
      },
      updateSuccessDialog: {
        show: false,
        title: "修改成功",
        img: require("@/assets/image/ads/mail.svg"),
        desc: "請使用您的新密碼重新登入",
        btnText: "重新登入",
      },
    };
  },
  mounted() {
    this.Account_GetAccountSettingApi(this.$store.state.username);
  },
  methods: {
    //#region 更新密碼
    UpdatePwd() {
      let vaild = false;
      if (this.$refs.form.validate()) {
        vaild = true;
      }
      if (
        this.updatePwdDialog.field1.value !== this.updatePwdDialog.field2.value
      ) {
        this.updatePwdDialog.field2.errorMsg =
          "兩次密碼輸入不一致，請重新輸入。";
        vaild = true;
      }

      if (this.userEmail === this.updatePwdDialog.field1.value) {
        this.updatePwdDialog.field2.errorMsg =
          "密碼不得與帳號相同，請重新輸入。";
        vaild = true;
      }

      if (!vaild) return;

      this.updatePwdDialog.loading = true;

      let data = {
        email: this.$store.state.username,
        password: this.updatePwdDialog.field1.value,
      };

      this.Account_UpdatePwdApi(data);
      //   setTimeout(() => {
      //     this.$refs.form.resetValidation();
      //     this.updatePwdDialog.show = false;
      //     this.updateSuccessDialog.show = true;
      //   }, 1000);

      //   setTimeout(() => {
      //     this.updatePwdDialog.loading = false;
      //   }, 2000);
    },
    //#endregion
    //#region 取消更新密碼
    CancelUpdatePwd() {
      this.updatePwdDialog.show = false;
      this.$refs.form.resetValidation();
      this.updatePwdDialog.field2.errorMsg = "";
    },
    //#endregion
    //#region 重新登入
    ReLogin() {
      this.$router.push({ name: "SignIn" });
    },
    //#endregion
    //#region Get帳號資訊
    Account_GetAccountSettingApi(email) {
      Account_GetAccountSetting(email)
        .then((res) => {
          this.userEmail = res.data.data.email;
          this.safety.pwd.isThirdParty = res.data.data.isThridPartySignIn;
          this.safety.pwd.updateDate = res.data.data.pwdUpdateTime;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //#endregion
    //#region 更新密碼API
    Account_UpdatePwdApi(data) {
      Account_UpdatePwd(data)
        .then(() => {
          this.updatePwdDialog.show = false;
          this.updateSuccessDialog.show = true;
          // 重登
          localStorage.removeItem("_token");
          localStorage.removeItem("_emailEncrypt");
        })
        .catch((err) => {
          this.updatePwdDialog.show = false;
          console.log(err.response.data.message);
        })
        .finally(() => {
          this.$refs.form.resetValidation();
          this.updatePwdDialog.loading = false;
        });
    },
    //#endregion
  },
};
</script>

<style scoped></style>
